import { OrderKeys } from '../../../../ts/models/OrderKeys';
import { OptionsDictionary } from '../../../../ts/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '../../../../ts/models/sort/SortOptionsHelper';

export const siteUserSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'siteRole': createNonDisplayOptionDefinition('siteRole', OrderKeys.siteRole),
  'lastSignIn': createNonDisplayOptionDefinition('lastSignIn', OrderKeys.lastSignIn),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
};
